// extracted by mini-css-extract-plugin
module.exports = {"containerBox":"style_containerBox__Qvn-0","imgBox":"style_imgBox__30ovv"};